import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";
import { message } from "antd";
import { MEAL_BASE_URL } from "configs/AppConfig";

//CREATE ACTION
export const deleteScheduleItem = createAsyncThunk("deleteScheduleItem", async ({ scheduleId, menu_item }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.delete(`${MEAL_BASE_URL}mealSchedule/${scheduleId}/items/${menu_item.id}`);
		message.success("Menu item has been deleted successfully!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		message.error(err.response.data?.message || "Failed to delete menu item");
		return rejectWithValue(err.response.data);
	}
});

const ScheduleItemDeleteSlice = createSlice({
	name: "ScheduleItemDeleteSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetScheduleItemDeleteState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(deleteScheduleItem.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(deleteScheduleItem.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(deleteScheduleItem.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetScheduleItemDeleteState } = ScheduleItemDeleteSlice.actions;
export default ScheduleItemDeleteSlice.reducer;
